import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const PostMedia = ({ post }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true);

  const handlePlayPause = () => {
    setIsPlaying(!isPlaying);
  };

  const handleMuteToggle = () => {
    setIsMuted(!isMuted);
  };

  if (post?.mediaType === 'video') {
    return (
      <div className="relative w-full bg-black">
        <div className="aspect-[9/16] md:aspect-video max-h-[70vh] mx-auto">
          <video
            className="w-full h-full object-contain"
            poster={post?.videoThumbnail}
            loop
            playsInline
          >
            <source src={post?.mediaUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          <div className="absolute inset-0 flex items-center justify-center">
            <button
              onClick={handlePlayPause}
              className="w-16 h-16 md:w-20 md:h-20 bg-black/50 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-black/70 transition-base touch-target"
              aria-label={isPlaying ? "Pause video" : "Play video"}
            >
              <Icon
                name={isPlaying ? "Pause" : "Play"}
                size={32}
                color="white"
              />
            </button>
          </div>

          <div className="absolute bottom-4 right-4 flex flex-col gap-2">
            <button
              onClick={handleMuteToggle}
              className="w-10 h-10 bg-black/50 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-black/70 transition-base touch-target"
              aria-label={isMuted ? "Unmute video" : "Mute video"}
            >
              <Icon
                name={isMuted ? "VolumeX" : "Volume2"}
                size={20}
                color="white"
              />
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full bg-muted">
      <div className="max-w-4xl mx-auto">
        <Image
          src={post?.mediaUrl}
          alt={post?.mediaAlt}
          className="w-full h-auto object-contain max-h-[70vh]"
        />
      </div>
    </div>
  );
};

export default PostMedia;